import * as yup from "yup";
import { connectionsTableColumnsKeys } from "@/features/ConnectionsTable/model";

export const modalTableSettingSchema = yup.object().shape({
  columnsState: yup
    .object()
    .shape({
      [connectionsTableColumnsKeys.person]: yup.boolean().required(),
      [connectionsTableColumnsKeys.title]: yup.boolean().required(),
      [connectionsTableColumnsKeys.connectedAs]: yup.boolean().required(),
      [connectionsTableColumnsKeys.additionalInformation]: yup.boolean().required(),
      [connectionsTableColumnsKeys.activity]: yup.boolean().required(),
      [connectionsTableColumnsKeys.industry]: yup.boolean().required(),
      [connectionsTableColumnsKeys.role]: yup.boolean().required(),
      [connectionsTableColumnsKeys.birthday]: yup.boolean().required(),
    })
    .required()
    .test("at-least-one-true", "*Fill in at least one of the fields", (value) =>
      Object.values(value).find((item) => item),
    ),
});

export type ModalTableSettingFormValues = yup.InferType<typeof modalTableSettingSchema>;
